import React, { Component } from "react";
import "./index.css";
import { CASEMASTERS_LOGO_URL } from "../../constants/urls.js";
import HamburgerMenu from "./Components/HamburgerMenu";
import MobileMenu from "./Components/MobileMenu";
import MobileSearchModal from "./Components/SearchModal";
import SearchBar from "./Components/SearchBar";
import { Link, push } from "redux-little-router";
import { Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import { signout } from "../../actions/userActions";
import { selectUser, isLoggedInUser, selectUserId } from "../../util/selectors";
import NotificationsIndicator from "./Components/NotificationsIndicator";
import NotificationIcon from "./Components/NotificationsIndicator/componenets/NotificationIcon";
import ProfilePicture from "../ProfilePicture";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState({ open: !this.state.open });
    document.getElementById("body").className = this.state.open ? "" : "menu-opened";
  }
  render() {
    const { authorized, userId } = this.props;
    const options = [
      {
        key: "user",
        text: "My Profile",
        icon: "user",
        onClick: this.props.push.bind(null, `/profile/${userId}`),
      },
      {
        key: "preferences",
        text: "Preferences",
        icon: "settings",
        onClick: this.props.push.bind(null, `/preferences`),
      },
      {
        key: "collections",
        text: "Collections",
        icon: "bookmark",
        onClick: this.props.push.bind(null, `/profile/${userId}/collections`),
      },
      {
        key: "sign-out",
        text: "Sign Out",
        icon: "sign out",
        onClick: this.props.signout,
      },
    ];
    return (
      <div className="header-wrapper">
        <header className="main-header">
          <div className="-header-wrapper">
            <Link href="/">
              <img src={CASEMASTERS_LOGO_URL} alt="CaseMasters" className="-logo" />
            </Link>
            <ul className={`-nav-bar -desktop`}>
              <li>
                <SearchBar />
              </li>
              <li>{authorized && <NotificationsIndicator />}</li>
              <li>
                {authorized && (
                  <Link href="/newcase" className="-new-case">
                    New Case
                  </Link>
                )}
              </li>
              <li>
                {authorized && (
                  <Dropdown
                    trigger={
                      <ProfilePicture
                        userId={this.props.user.uid}
                        size="xs"
                        fallbackUrl={this.props.user.picture}
                        className="ui avatar image"
                      />
                    }
                    options={options}
                    pointing="top right"
                    icon={null}
                  />
                )}
              </li>
            </ul>
          </div>
          <div className="-mobile-nav">
            <MobileSearchModal />
            {authorized && (
              <Link href="/notifications">
                <NotificationIcon />
              </Link>
            )}
            {authorized && <HamburgerMenu open={this.state.open} toggleMenu={this.toggleMenu} />}
          </div>
        </header>
        {authorized && <MobileMenu open={this.state.open} toggleMenu={this.toggleMenu} />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const authorized = isLoggedInUser(state);
  return {
    authorized,
    user: selectUser(state),
    userId: selectUserId(state),
  };
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    signout: () => dispatch(signout()),
    // TODO: refactor /profile to /user/:username
    push: path => dispatch(push(path)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js